"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bar = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ActionsTricolon = require("../ActionsTricolon");

var _Container = require("./Container");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// width: ${({ width }) => width || '0'};
// visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
var BarStyled = _styledComponents["default"].div.withConfig({
  displayName: "Bar__BarStyled",
  componentId: "sc-1cs55rk-0"
})(["width:100%;box-sizing:border-box;height:7px;border:1px solid ", ";background-color:", ";"], function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, function (_ref2) {
  var color = _ref2.color;
  return color;
}); // height: ${({ master }) => (master ? '9px' : '6px')};
// background-color: rgba(84, 184, 248, 0.3);


var BarTitle = _styledComponents["default"].div.withConfig({
  displayName: "Bar__BarTitle",
  componentId: "sc-1cs55rk-1"
})(["width:100%;color:#ffffff;font-size:12px;display:flex;flex-direction:row;justify-content:", ";"], function (_ref3) {
  var position = _ref3.position;
  return position || 'flex-start';
});

var Bar = function Bar(props) {
  return /*#__PURE__*/_react["default"].createElement(_Container.Container, props, /*#__PURE__*/_react["default"].createElement(BarTitle, props, props.actions && props.actions.length > 0 ? /*#__PURE__*/_react["default"].createElement(_ActionsTricolon.ActionsTricolon, _extends({
    tooltipPlacement: "left"
  }, props)) : null, props.caption), /*#__PURE__*/_react["default"].createElement(BarStyled, props));
}; // Bar.propTypes = {
//   width: PropTypes.string,
//   caption: PropTypes.any,
//   actions: PropTypes.array,
//   color: PropTypes.string,
//   borderColor: PropTypes.string,
//   visible: PropTypes.bool
// }


exports.Bar = Bar;
Bar.defaultProps = {
  width: '0',
  caption: '',
  actions: null,
  color: '#305473',
  borderColor: '#54b8f8',
  visible: true
};